module.exports = __webpack_public_path__ + "static/media/SF-6-A (1).d5fed747.mp3";